const Modulis_Grid =
    {
        /**
         * Nastaveni sirky gridu po prechodu na jiny tab
         */
        init: function()
        {
            // Kliknuti na novy  tab
            $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                var grid;

                // Nastaveni sirky gridu po prechodu na jiny tab
                if (grid = $('.ui-jqgrid-btable:visible')) {
                    grid.each(function (index) {
                        gridId = $(this).attr('id');
                        gridParentWidth = $('#gbox_' + gridId).parent().width();
                        $('#' + gridId).setGridWidth(gridParentWidth);
                    });
                }
            });

            // Zarovnani strankovani doprostred gridu
            $('div.ui-jqgrid').find('td[id$="_pager_left"]').each(function(i, element) {
                $(element).removeAttr('style');
            });
        },

        /**
         * Vyber sloupecku, ktere chce uzivatel videt v gridu
         *
         * Ulozi vybrane sloupce do nastaveni uzivatele
         */
        sloupce: function (grid, gridName) {
            $(grid).jqGrid('columnChooser', {
                done: function (perm) {
                    if (perm) {
                        this.jqGrid('remapColumns', perm, true);
                        $('#' + gridName).setGridWidth($('#gbox_' + gridName).parent().width());

                        Modulis_Grid.sloupceUlozeni(grid, gridName);
                    }
                }
            });
        },

        sloupceUlozeni: function (grid, gridName) {
            "use strict";
            var colModel = $(grid).jqGrid('getGridParam', 'colModel'),
                columns = [],
                url = $(location).attr('pathname');

            $(colModel).each(function (i, col) {
                if (false === col.hidden && typeof col.hidedlg == 'undefined') {
                    columns[i] = col.name;
                }
            });

            url.indexOf(1);
            url.toLowerCase();
            var modul = url.split("/")[1];

            $.ajax({
                type: 'post',
                url: '/uzi/uzivatele/ajax/ulozeni-sloupcu-gridu',
                data: {modul: modul, nazev: gridName, sloupce: columns},
                dataType: "json",
                global: false,
                beforeSend: function () {
                    Lemo_Alert.addInfo('Ukládám vybrané sloupce...', 'ulozSloupceGridu');
                },
                complete: function () {
                    Lemo_Alert.closeById('ulozSloupceGridu');
                }
            });
        },

        clear: function (grid, gridName) {
            var gridSelector = $('#' + gridName);
            gridSelector.jqGrid('clearGridData', true);

            if (typeof gridSelector[0].clearToolbar !== "undefined") {
                gridSelector[0].clearToolbar();
            }

            gridSelector.trigger('reloadGrid');
        },

        reset: function (grid, gridName) {
            // var colSortName = $(grid).jqGrid('getGridParam', 'sortname');
            // var colSortOrder = $(grid).jqGrid('getGridParam', 'sortorder');
            var colModel = $(grid).jqGrid('getGridParam', 'colModel');

            // $('#gbox_' + gridName).find('.s-ico > span').addClass('ui-state-disabled').addClass('ui-disabled');
            // $('#jqgh_' + gridName + '_' + colSortName).find('.ui-icon-' + colSortOrder).removeClass('ui-state-disabled').removeClass('ui-disabled');

            var test = $('#' + gridName)
                .jqGrid('setGridParam', {page: 1})
                .trigger('clearToolbar')
                .trigger('clearData')
                .trigger('reloadGrid');
        },

        resize: function () {
            var grid = $('.ui-jqgrid-btable:visible');

            if (grid) {
                grid.each(function () {
                    var gridId = $(this).attr('id'),
                        gridParentWidth = $('#gbox_' + $(this).attr('id')).parent().width();
                    $('#' + gridId).setGridWidth(gridParentWidth);
                });
            }
        }
    }

window.Modulis_Grid || (window.Modulis_Grid = Modulis_Grid);
